module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxwYXRoIGZpbGw9IiNmZmU3MDAiIGQ9Ik01MTIuMDA0IDUxMS45OTNIMFYwaDUxMi4wMDR6Ii8+CiAgICA8cGF0aCBmaWxsPSIjMzZhMTAwIiBkPSJNNTEyLjAwNCAxNzAuNjY0SDBWMGg1MTIuMDA0eiIvPgogICAgPHBhdGggZmlsbD0iIzAwNmRiYyIgZD0iTTUxMi4wMDQgNTExLjk5M0gwVjM0MS4zM2g1MTIuMDA0eiIvPgogIDwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/ga.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/ga.svg
// module chunks = 0